import type { UserModel, PermissionModel } from '@/types';

export interface RoleModel {
    id: number;
    name: string;
    users: UserModel[];
    permissions: PermissionModel[];
}
